import { useMutation } from "@tanstack/react-query";

import { addConsentDocument } from "../api/consentDocuments";

export const useAddConsentDocument = () => {
  return useMutation({
    mutationFn: addConsentDocument,
  });
};
